<template>
  <div>
    <div class="selectBox">
      <el-form ref="paramsList" :model="params">
        <QS-search maxLine="2">
          <!-- 内容区域-->
          <el-form-item label="事故ID" prop="id">
            <el-input
              v-model.trim="params.id"
              clearable
              placeholder="请输入"
              v-number:integer="18"
            />
          </el-form-item>
          <el-form-item label="车牌号" prop="carId">
            <el-select
              v-model="params.carId"
              filterable
              remote
              reserve-keyword
              clearable
              placeholder="请输入"
              :remote-method="(query) => { remoteMethod(query) }"
              :loading="oLoading.fuzzy"
            >
              <el-option
                v-for="item in carList"
                :key="'options4' + item.id"
                :label="item.plateNo"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="订单ID" prop="orderId">
            <el-input
              v-model.trim="params.orderId"
              clearable
              placeholder="请输入订单ID"
              maxlength="18"
              v-interage="true"
            />
          </el-form-item>
          <el-form-item label="报案日" prop="value1">
            <el-date-picker
              v-model="params.value1"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="dateTime(params.value1)"
              value-format="yyyy-MM-dd"
            />
          </el-form-item>
          <el-form-item label="事故责任" prop="accidentBlame">
            <el-select
              placeholder="全部"
              v-model="params.accidentBlame"
              clearable
            >
              <el-option
                v-for="item in accidentResponsibilityList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="事故状态" prop="accidentStatus">
            <el-select
              placeholder="全部"
              v-model="params.accidentStatus"
              clearable
            >
              <el-option
                v-for="item in accidentStatusList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="结算状态" prop="settlementStatus">
            <el-select
              placeholder="全部"
              v-model="params.settlementStatus"
              clearable
            >
              <el-option
                v-for="item in settlementFormList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="所属部门" prop="deptIdList">
            <DeptSelect v-model="params.deptIdList" filterable clearable multiple />
          </el-form-item>
          <!-- 按钮区域，slot方式，各个按钮要单独用item包裹-->
          <template slot="moreBtn">
            <el-form-item>
              <el-button
                :loading="oLoading.search"
                type="primary"
                size="small"
                @click="selectBtn"
              >
                查询
              </el-button>
            </el-form-item>
            <el-form-item>
              <el-button size="small" @click="Reset"> 重置 </el-button>
            </el-form-item>
            <el-form-item>
              <export
                :exportTemplate="exportTemplate"
                filename="事故管理列表.xlsx"
                :params="params"
                v-if="judgePermission('vehicle_accident_list_export')"
              />
            </el-form-item>
          </template>
        </QS-search>
      </el-form>
    </div>
    <el-button
      type="primary"
      @click="JumpAdd"
      v-if="judgePermission('vehicle_accident_list_create')"
    >新建事故</el-button>
    <el-button
      type="primary"
      @click="importFile(true)"
      v-if="judgePermission('batchAccidentImport')"
    >批量导入事故信息</el-button>
    <CarAccidentList
      :loading="oLoading"
      :params="params"
      :isCarDetail="false"
      ref="CarAccidentList"
    />
    <BatchAddModal
      :visible="batchAddVisible"
      @closed="importFile(false)"
    />
  </div>
</template>
<script>
// eslint-disable-next-line import/no-cycle
import { FuzzySearch } from '@/api/domain/cars'
import selectOption from '@/store/dict/selectOptionDict'
import CarAccidentList from '../components/carAccidentList.vue'
import BatchAddModal from '../components/batchAddModal.vue'

export default {
  components: {
    CarAccidentList,
    BatchAddModal,
  },
  data() {
    return {
      oLoading: {
        search: false,
        fuzzy: false,
      },
      exportTemplate: 'Accident',
      params: {
        id: '',
        carId: '',
        orderId: '',
        plateNo: '',
        reportDateBegin: '', // 保案日开始时间
        value1: '',
        reportDateEnd: '', // 保案日结束时间
        accidentBlame: '', // 事故责任  1主要责任 2次要责任 3无责
        accidentStatus: '', // 事故状态   1待处理  2处理中  3已完成
        pageSize: '',
        settlementStatus: '', // 结算状态
        pageNum: '',
        deptIdList: [],
      },
      carList: [],
      batchAddVisible: false,
    }
  },
  async mounted() {
    const { value1 = '', accidentBlame = '', orderId = '', id = '', deptId = '', plateNo = '' } = this.$route.query
    if (value1 !== '') {
      this.params.value1 = JSON.parse(value1)
      this.params.reportDateBegin = this.params.value1[0]
      this.params.reportDateEnd = this.params.value1[1]
    }
    if (accidentBlame !== '') {
      this.params.accidentBlame = Number(accidentBlame)
    }
    if (orderId !== '') {
      this.params.orderId = Number(orderId)
    }
    if (deptId !== '') {
      this.params.deptIdList = [Number(deptId)]
    }
    if (id !== '') {
      this.params.carId = id
    }
    this.$refs.CarAccidentList.paginationEvent({
      pagination: {
        pageSize: this.params.pageSize || 10,
        pageNum: 1,
      },
    })
    if (plateNo !== '') {
      await this.remoteMethod(plateNo)
      const currentCar = this.carList.find((item) => item.plateNo === plateNo)
      this.params.carId = currentCar.id || id
    }
  },
  methods: {
    /* 新增 */
    JumpAdd() {
      this.$router.push({ path: '/vehicle/accident/add' })
    },
    /* 报案日 */
    dateTime(data) {
      if (!data) {
        this.params.reportDateBegin = ''
        this.params.reportDateEnd = ''
        return
      }
      this.params.reportDateBegin = data[0]
      this.params.reportDateEnd = data[1]
    },
    /* 查询 */
    selectBtn() {
      this.$refs.CarAccidentList.paginationEvent({
        pagination: {
          pageSize: this.params.pageSize || 10,
          pageNum: 1,
        },
      })
    },
    /* 车牌号 */
    async remoteMethod(query, state) {
      if (query.length >= 4) {
        this.oLoading.fuzzy = true
        const { code, data } = await FuzzySearch({
          plateNo: query,
          state: 1,
        })
        this.oLoading.fuzzy = false
        if (code !== 1) return
        this.carList = data
        // 如果是url上带车牌号和车辆id，请求到车牌号后重新进行列表查询
        if (state === 'directSearch') {
          this.selectBtn()
        }
      }
    },
    /* 重置 */
    Reset() {
      this.$refs.paramsList.resetFields()
      this.params.reportDateBegin = ''
      this.params.reportDateEnd = ''
      this.selectBtn()
    },
    // 批量导入事故信息
    importFile(value) {
      this.batchAddVisible = value
    },
  },
  computed: {
    // 事故状态列表
    accidentStatusList() {
      return this.dictParseList(selectOption.accidentStatusDict, true)
    },

    // 事故责任列表
    accidentResponsibilityList() {
      return this.dictParseList(selectOption.accidentResponsibilityDict, true)
    },
    // 结算状态
    settlementFormList() {
      return this.dictParseList(selectOption.settlementForm, true)
    },
  },
}
</script>
<style lang="less" scoped>
.el-tabs {
  font-size: 14px;
}
.selectBox {
  margin-bottom: 16px;
  .btnText {
    padding-top: 5px;
    font-size: 14px;
    color: #2e7eff;
  }
}
.content {
  max-height: 500px;
  padding: 0;
  font-size: 14px;
}
</style>
